import React, { useState } from 'react'
import Scroll from 'react-scroll'

import AmbientPicture from './AmbientPicture'
import Actors from './Actors'
import Directors from './Directors'
import MovieLength  from '../MoviesGeneral/MovieLength'
import Fsk from './Fsk'
import ButtonToggleMovieDetails from './ButtonToggleMovieDetails'
import MovieTimes from './MovieTimes'
import ReactScrollLink from '../General/ReactScollLink'
import Description from './Description'
import Genres from '../MovieDetails/Genres'
import ShareButtons from '../General/ShareButtons'
import TrailerLarge from '../Trailer/TrailerLarge'
import seperateAttributes from '../functions/seperateAttributes'
import ItemAttributes from '../PosterFormatItem/ItemAttributes'
import Translation from '../General/Translation'
import MovieMerchandising from '../MovieMerchandising'
import TrailerSmall from '../Trailer/TrailerSmall'
import FskWrapper from './FskWrapper'
import MovieTimesContainer from './MovieTimesContainer'

let Element = Scroll.Element

const MovieInformation = ({ 
    itemID, 
    translation,
    activePerformance=false, 
    toggleMovieDatesOnMobileView, 
    attributeStyling,
    isMobile,
    currentDateActive,
    dayFilters, 
    moviesData, 
    elbenwald,
    filterType,
    theme,
    filterValue,
    queryStringValues,
    itemLink,
    detailsOpen,
    backgroundImage,
    trailerImage,
    overviewFilterIgnoreOnPerformances,
    scrollToPosition, 
    closeOffset=-200,
    informationStyling,
    onOpenDetails, 
    onCloseDetails, 
    onCloseInformation, 
    hideCinemaSelector,
    onOpenIframe=null, 
    activeCinema
}) => {

    if(!moviesData[itemID]) {
        return ''
    }
    const movieData = moviesData[itemID]
    const { title, descriptionShort, actors, directors, trailerURL, length, fsk, titleDisplay, subTitle, technologyAttributes, origTitle, genres, elbenwaldArticles, images } = movieData

    const containsOv = _.find(technologyAttributes, attribute => {
        return attribute.id === 'ovfwefwefwe'
    })
    const { technologyAttributesWithIcons, technologyAttributesWithoutIcons } = seperateAttributes(technologyAttributes)
    const noAttributesToDisplay = ((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) && (technologyAttributesWithoutIcons.length === 0) ? true : false
    const noAttributesWithIconsToDisplay = ((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) ? true : false
    const currentTitle = titleDisplay ? titleDisplay : containsOv && origTitle ? origTitle : title 
    const hasTrailerClass = !trailerURL ? '' : ' has-trailer'
    const showAmbientImage = theme === 'Arthouse' ? isMobile ? true : false : true

    return (
        <Element name={scrollToPosition + ' movieInformation'}>
            <div className={'movie-information ' + theme.toLowerCase() + ' ' + informationStyling} id={'movie-information'}> 

                <div className="close-button-wrapper">
                    <ReactScrollLink to={scrollToPosition} offset={closeOffset}>
                        <div className="close-button cursor-pointer" onClick={() => {
                            onCloseInformation({movieTitle: currentTitle})
                            toggleMovieDatesOnMobileView('')
                        }}
                        >
                            {isMobile ? (
                                <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                    <polygon className="cls-1" points="13.73 30 14.83 28.99 2.71 15.74 30 15.74 30 14.24 2.71 14.24 14.82 1.01 13.71 0 0 14.99 13.73 30"/>
                                </svg>
                            ) : (
                                <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                    <polygon className="cls-1" points="25 1.06 23.94 0 12.5 11.44 1.06 0 0 1.06 11.44 12.5 0 23.94 1.06 25 12.5 13.56 23.94 25 25 23.94 13.56 12.5 25 1.06"/>
                                </svg>
                            )}
                        </div>
                    </ReactScrollLink>
                </div>

                {showAmbientImage && <div className='top-wrapper'>
                    <AmbientPicture isMobile={isMobile} image={backgroundImage}/>
                    {trailerURL && isMobile && <TrailerSmall      
                        trailerURL={trailerURL}
                        fsk={fsk}
                        translation={translation}/>}
                </div>}

                <div className ={'movie-information-content-wrapper'  + hasTrailerClass}>
                    <div className ="movie-content">

                        {!isMobile && <div className="title">
                            <h2 className={'title-xlarge-bold'} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: currentTitle}}></h2>
                            {subTitle && <p className="title-xlarge-theatre item-subtitle" style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: subTitle}}></p>}
                        </div>}

                        {isMobile && <div className="title">
                            <h2 className={'title-xlarge-bold'} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: currentTitle}}></h2>
                            {subTitle && <p className="title-xlarge-theatre item-subtitle" style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: subTitle}}></p>}
                        </div>}


                        <div className='information-container'>    
                            <div className={'information'}>
                                {!noAttributesToDisplay && <div className='attributes'>
                                    {!noAttributesToDisplay && <p className='text-bold attribute-wrapper-title'><Translation id="availableIn" trans={translation}>Verfügbar in</Translation>:</p>}
                                    <div className='attributes-container'>
                                        {technologyAttributesWithIcons.length !== 0 && !noAttributesWithIconsToDisplay && <div className='attributes-with-icons'>
                                            <ItemAttributes attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true} />
                                        </div>}
                                        {technologyAttributesWithoutIcons.length !== 0 && <div className='attributes-without-icons'>
                                            <ItemAttributes attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithoutIcons} />
                                        </div>}
                                    </div>
                                </div>}
                               {!isMobile && <div className="actors">
                                    <Actors actors={actors} translation={translation}/>
                                    <Directors directors={directors} actors={actors} translation={translation} />
                                </div>}

                                {!isMobile && <Description movieData={movieData} translation={translation}/>}

                                <div className={'more'}>
                                    <div className='info-bundle'>
                                        <div className='fsk-length-wrapper'>
                                        <FskWrapper fsk={fsk}/>
                                            <MovieLength length={length} translation={translation}/>
                                        </div>
                                        <Genres genres={genres} translation={translation}/>
                                        {!isMobile && <MovieMerchandising
                                            ids={elbenwaldArticles} 
                                            data={elbenwald}
                                            movieTitle={currentTitle}
                                            translation={translation}
                                        />}
                                    </div>

                                    {!isMobile && <ButtonToggleMovieDetails 
                                        movieTitle={currentTitle}
                                        movieId={itemID}
                                        translation={translation}
                                        detailsOpen={detailsOpen}
                                        scrollToPosition={scrollToPosition}
                                        onOpenDetails={onOpenDetails}
                                        onCloseDetails={onCloseDetails}
                                    />}
                                </div>

                                {!isMobile && itemLink && <ShareButtons 
                                    url={itemLink}
                                    title={currentTitle}
                                    description={descriptionShort}
                                    translation={translation}
                                />}
                            </div>
                            {trailerURL && !isMobile && <TrailerLarge
                                trailerURL={trailerURL}
                                isMobile={isMobile}
                                theme={theme}
                                fsk={fsk}
                                backgroundImage={trailerImage}
                                translation={translation}
                            />}
                        </div>
                        <MovieTimesContainer 
                            hideCinemaSelector={hideCinemaSelector}
                            activeCinema={activeCinema}
                            queryStringValues={queryStringValues}
                            activePerformance={activePerformance}
                            filterValue={filterValue}
                            dayFilters={dayFilters}
                            filterType={filterType}
                            movieData={movieData} 
                            onClick={toggleMovieDatesOnMobileView}
                            additionalClass={' show-on-mobile'}
                            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                            currentDateActive={currentDateActive}
                            scrollToPosition={scrollToPosition}
                            onOpenIframe={onOpenIframe}
                        />
                        {isMobile && <div className="actors">
                            <Actors actors={actors} translation={translation}/>
                            <Directors directors={directors} actors={actors} translation={translation} />
                        </div>}

                        {isMobile && <Description movieData={movieData} translation={translation}/>}
                        {isMobile && <ButtonToggleMovieDetails 
                            movieTitle={currentTitle}
                            movieId={itemID}
                            translation={translation}
                            detailsOpen={detailsOpen}
                            scrollToPosition={scrollToPosition}
                            onOpenDetails={onOpenDetails}
                            onCloseDetails={onCloseDetails}
                        />}
                        {isMobile && itemLink && <ShareButtons 
                            url={itemLink}
                            title={currentTitle}
                            description={descriptionShort}
                            translation={translation}
                        />}
                        {isMobile && <MovieMerchandising
                            ids={elbenwaldArticles} 
                            data={elbenwald}
                            movieTitle={currentTitle}
                            translation={translation}
                        />}
                    </div>
                </div>
            </div>
        </Element>
    )
}

export default MovieInformation